import React from "react";
import styled from "styled-components";

import { hexToRgb } from "../../utils/hexToRgb";

type Status = "online" | "offline";

interface TldStatusProps {
  label: string;
  status: Status;
  action: () => void;
}

const TldStatus: React.FC<TldStatusProps> = ({
  label,
  status,
  action,
}: TldStatusProps) => {
  return (
    <Container>
      <TldContainer status={status}>
        <Label onClick={action}>{label}</Label>
      </TldContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90px;
`;

const Label = styled.span`
  color: ${(props) => props.theme.colors.blue};
  font-size: 14px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const TldContainer = styled.div<{ status: Status }>`
  padding: 8px 12px;
  border-radius: 8px;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: ${(props) => {
    switch (props.status) {
      case "online":
        return `rgba(${hexToRgb(props.theme.colors.green)}, 0.5)`;
      case "offline":
        return props.theme.colors.lightGrey;
      default:
        return "transparent";
    }
  }};
`;

export default TldStatus;
